import { inject, Injectable } from '@angular/core';

import { Store } from '@ngrx/store';
import { map } from 'rxjs/operators';

import { filterBoolean } from '@core/common-legacy';
import {
  IntelligenceSettingsActions,
  IntelligenceSettingsSelectors,
} from '@core/intelligence-data';
import type { IntelligenceSettingsState } from '@core/intelligence-types';

@Injectable({ providedIn: 'root' })
export class IntelligenceSettingsDataService {
  private readonly store = inject(Store);
  private readonly settingsState$ = this.store.select(IntelligenceSettingsSelectors.state);

  public readonly settingsState = this.store.selectSignal(IntelligenceSettingsSelectors.state);
  public settingsLoaded$ = this.settingsState$.pipe(map(state => state.loaded));

  public toggleAiFeature(key: keyof IntelligenceSettingsState, value: boolean) {
    this.store.dispatch(IntelligenceSettingsActions.update({ payload: { [key]: value } }));
  }

  public getFeatureState(key: keyof IntelligenceSettingsState) {
    return this.settingsState$.pipe(
      map(state => state.data),
      filterBoolean,
      map(data => data[key]),
    );
  }

  public load() {
    this.store.dispatch(IntelligenceSettingsActions.fetch());
  }

  public fetchIfNotLoaded() {
    const { pending, loaded } = this.settingsState();
    if (loaded || pending) return;

    this.load();
  }
}
